<template>
  <div class="analytics-outer">
    <div class="detail-header">
      <div class="detail-poi">
        <van-dropdown-menu>
          <van-dropdown-item
            v-model="poiId"
            :options="poiList"
            @change="onPoiChange"
          />
        </van-dropdown-menu>
      </div>
      <div
        class="detail-datepicker"
        @click="rangeShow = !rangeShow"
      >
        <span>{{ displayMinDate }}~{{ displayMaxDate }}</span>
        <van-icon :name="rangeShow ? 'arrow-up' : 'arrow-down'" />
      </div>
      <div class="detail-uptime">
      </div>
      <van-calendar
        v-model="rangeShow"
        :min-date="date.minDate"
        :max-date="date.maxDate"
        :default-date="date.selectedDate"
        max-range="30"
        allow-same-day
        type="range"
        color="#FE8C00"
        @confirm="onConfirm"
      />
    </div>
    <div class="content">
      <canvas id="profit-chart"></canvas>
    </div>
  </div>
</template>

<script>
import Icon from 'vant/lib/icon';
import Calendar from 'vant/lib/calendar';
import DropdownMenu from 'vant/lib/dropdown-menu';
import DropdownItem from 'vant/lib/dropdown-item';
import F2 from '@antv/f2';
import MarketingApi from '@/api/marketing';
import tracker from '@/util/tracker';

import 'vant/lib/icon/style';
import 'vant/lib/calendar/style';
import 'vant/lib/dropdown-menu/style';
import 'vant/lib/dropdown-item/style';


export default {
  name: 'AnalyticsInHome',
  components: {
    [Icon.name]: Icon,
    [Calendar.name]: Calendar,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
  },
  data() {
    return {
      rangeShow: false,
      todayDate: new Date(),
      poiId: 0,
      poiList: [{
        text: '全部门店', value: 0,
      }],
      data: [],
      date: {
        minDate: this.todayDate,
        maxDate: this.todayDate,
        selectedDate: [this.todayDate, this.todayDate],
      },
    };
  },
  computed: {
    displayMinDate() {
      return this.formatDate(this.date.selectedDate[0]);
    },
    displayMaxDate() {
      return this.formatDate(this.date.selectedDate[1]);
    },
  },
  created() {
    this.setDate();
  },
  async mounted() {
    this.chart = new F2.Chart({
      id: 'profit-chart',
      pixelRatio: window.devicePixelRatio,
    });
    await this.getPoi();
    await this.getData();
    this.$nextTick(() => {
      this.getTrend();
    });
  },
  methods: {
    initDataByRange(range) {
      const [startDate, endDate] = range;
      const dayUnit = 8.64e7;
      let startTime = startDate.getTime();
      const endTime = endDate.getTime();
      const temp = [];
      for (;startTime <= endTime;) {
        temp.push({
          _key: 'adv_poi_pv',
          date: this.formatDateFillZero(new Date(startTime)),
          type: '曝光数据PV',
          value: 0,
        }, {
          _key: 'adv_poi_uv',
          date: this.formatDateFillZero(new Date(startTime)),
          type: '访问数据UV',
          value: 0,
        });
        startTime += dayUnit;
      }
      return temp;
    },
    formatDate(date) {
      return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
    },
    formatDateFillZero(date) {
      const fill = (num) => (num < 10 ? `0${num}` : num);
      return `${date.getFullYear()}/${fill(date.getMonth() + 1)}/${fill(date.getDate())}`;
    },
    async getPoi() {
      const data = await MarketingApi.getPoi();
      if (data.data && data.data.records) {
        data.data.records.forEach(({ poiId, poiName }) => {
          this.poiList.push({ text: poiName, value: poiId });
        });
      }
    },
    async onConfirm(date) {
      if (date.length === 2) {
        tracker.sendModuleClick(this.$BID.ANALYTICS_SELECTED_DATE, null, this.$CID.AanlyticsAds);
        this.date.selectedDate = date;
        await this.getData();
        this.getTrend();
        this.rangeShow = false;
      }
    },
    async onPoiChange(value) {
      tracker.sendModuleClick(this.$BID.ANALYTICS_SELECTED_POI, null, this.$CID.AanlyticsAds);
      await this.getData(value);
      this.getTrend();
      this.rangeShow = false;
    },
    setDate() {
      const todayTime = Date.now();
      const dayUnit = 8.64e7;
      this.date = {
        maxDate: new Date(todayTime - dayUnit),
        minDate: new Date(todayTime - 30 * dayUnit),
        selectedDate: [new Date(todayTime - 7 * dayUnit), new Date(todayTime - dayUnit)],
      };
    },
    dateBeginTime(date) {
      date.setHours(0);
      date.setMinutes(0);
      date.setSeconds(0);
      date.setMilliseconds(0);
      return date.getTime();
    },
    dateEndTime(date) {
      date.setHours(23);
      date.setMinutes(59);
      date.setSeconds(59);
      date.setMilliseconds(0);
      return date.getTime();
    },
    async getData(poiId) {
      const [startDate, endDate] = this.date.selectedDate;
      // 先初始化一个结构数据
      // 原因是查出来的数据不一定按dt全量返回，也不一定有序
      const datares = this.initDataByRange(this.date.selectedDate);
      const { data } = await MarketingApi.getData({
        startDate: this.dateBeginTime(startDate),
        endDate: this.dateEndTime(endDate),
      }, poiId);
      if (data.length) {
        const { labels = [], values = [] } = data[0] || {};
        // 用查询数据覆盖初始化数据，保留初始化的0值。
        datares.forEach((item) => {
          const { _key: key, date } = item;
          // 从values找到行
          const tmp = values.find((records) => records.indexOf(date.replace(/\//g, '')) !== -1);
          // 找到当前key所属位置
          const idx = labels.indexOf(key);
          if (tmp && idx !== -1) {
            item.value = Number(tmp[idx]);
          }
        });
      }
      // console.log(JSON.stringify(datares, null, '  '));
      this.data = datares;
    },
    getTrend() {
      const { chart, data } = this;
      if (!chart) return;
      chart.clear();
      chart.source(data, {
        value: {
          tickCount: 10,
        },
        date: {
          type: 'timeCat',
          mask: 'MM/DD',
          range: [0, 1],
        },
      });
      chart.legend({
        position: 'bottom',
        offsetY: -5,
      });
      chart.tooltip({
        showCrosshairs: true,
        showTitle: false,
        showTooltipMarker: true,
        tooltipMarkerStyle: {
          fill: '#fff', // 设置 tooltipMarker 的样式
        },
        onChange(obj) {
          const items = obj.items;
          items[0].name = `${items[0].origin.date}`;
        },
      });
      chart.axis('date', {
        label: function label(text, index, total) {
          const textCfg = {
            textAlign: 'center',
          };
          // 第一个点左对齐，最后一个点右对齐，其余居中，只有一个点时左对齐
          if (index === 0) {
            textCfg.textAlign = 'left';
          } else if (index === total - 1) {
            textCfg.textAlign = 'right';
          }
          // textCfg.text = `day: ${text}`; // textCfg.text 支持文本格式化处理
          return textCfg;
        },
      });
      chart.line().position('date*value').color('type');
      chart.point().position('date*value').style({
        stroke: '#fff',
        lineWidth: 1,
      });
      chart.render();
    },
  },
};
</script>

<style lang="scss" scoped>
.analytics-outer {
  margin: 18px;
  padding: 0 36px;
  border-radius: 12px;
  padding: 30px 0;
  .content {
    margin: 24px 0;
    height: 443px;
    background-color: #fff;
    border-radius: 26px;
    #profit-chart {
      width: 100%;
      height: 100%;
    }
  }
}
.detail-header{
  display: flex;
  .detail-poi{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 260px;
    font-size: 28px;
    color: #111;
    margin-top: 4px;
    /deep/.van-dropdown-menu{
      height: auto;
      background: none;
      width: 180px;
    }
  }
  .detail-poi-arrow{
    flex-shrink: 0;
    position: relative;
    top: 6px;
    font-size: 28px;
  }
  .detail-datepicker{
    white-space: nowrap;
    flex: 1 1 0%;
    margin: 0 20px;
    font-size: 28px;
    color: #111;
  }
  .detail-uptime{
    flex-shrink: 0;
    color: #999;
    font-size: 22px;
    margin-top: 6px;
  }
}
</style>
